<script setup lang="ts">
import { onMounted, onUnmounted } from 'vue'
import { useGlobalSubscriptions } from '@/composables/useGlobalSubscriptions'
import AppSidebar from '@/components/AppSidebar.vue'
import Navbar from './components/Navbar.vue'

const { onMount, onUnmount } = useGlobalSubscriptions()

onMounted(() => {
  onMount()
})

onUnmounted(() => {
  onUnmount()
})
</script>

<template>
  <div class="flex min-h-svh w-full">
    <AppSidebar />
    <!-- Main content area with left margin for the rail (88px) -->
    <div class="flex flex-1 flex-col md:ml-[88px] overflow-x-hidden">
      <Navbar />
      <main class="flex flex-1 flex-col gap-4 p-4">
        <RouterView />
      </main>
    </div>
  </div>
</template>
